import { render, staticRenderFns } from "./ZoomResetFab.vue?vue&type=template&id=13248c19&lang=pug&"
import script from "./ZoomResetFab.vue?vue&type=script&lang=js&"
export * from "./ZoomResetFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ZoomResetFab.vue"
export default component.exports